// removed by extract-text-webpack-plugin
module.exports = {"popoverPane":"PopoverPane__popoverPane__1aibw","titleBar":"PopoverPane__titleBar__2jQKR","title":"PopoverPane__title__FqQcA"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Common/Popover/PopoverPane/PopoverPane.scss
// module id = 1733
// module chunks = 0